/**
 * Intro block explaining what this module does. Go into as much detail as needed,
 * the dev reading this should be able to understand what this module does
 * without having to read any code. List any plugins used.
 */

require('../plugins/jquery.matchHeight.js');

// Module events
export default function init() {

    $('.js-mh').matchHeight();
    
    $('.js-mh-all').matchHeight({
    	byRow: false
    });

};